import chatModule from '../chatModule';

function pinGameService($log, playTogetherService, gameService, eventStreamService, resources) {
    "ngInject";

    return {
        sendPinGameEvent: function (eventType, rootPlaceId, conversation) {
            var properties = {
                placeId: rootPlaceId,
                conversationId: conversation.id
            };
            eventStreamService.sendEventWithTarget(eventType,
                resources.eventStreamParams.actions.click,
                properties);
        },

        setPinGameData: function (conversation, parameters) {
            if (parameters && parameters.universeId) {
                var rootPlaceId = parameters.rootPlaceId;
                conversation.pinGame = {
                    universeId: parameters.universeId,
                    rootPlaceId: rootPlaceId,
                    placeName: parameters.placeName,
                    encodedPlaceName: parameters.encodedPlaceName,
                    actorUsername: parameters.actorUsername,
                    userId: parameters.userId
                }
                playTogetherService.setPlaceForShown(conversation);
            } else {
                conversation.pinGame = null;
                playTogetherService.setPlaceForShown(conversation);
            }
        },

        pinGame: function (conversation, universeId) {
            if (conversation && universeId) {
                gameService.setConversationUniverse(conversation.id, universeId);
            }
        },

        unpinGame: function (conversation) {
            if (conversation) {
                gameService.resetConversationUniverse(conversation.id);
            }
        }
    }
};

chatModule.factory("pinGameService", pinGameService);

export default pinGameService;